/* import __COLOCATED_TEMPLATE__ from './feature-activation-gate.hbs.js'; */
var _dec, _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import FeatureGateBase from './feature-gate-base';
import { computed } from '@ember/object';
let FeatureActivationGate = (_dec = computed('args.feature', 'userSubscriptions.featuramaFeatureStatusesResult.data'), _class = class FeatureActivationGate extends FeatureGateBase {
  get isActive() {
    return this.userSubscriptions.isFeatureActive(this.args.feature);
  }
  get showContent() {
    if (this.isLoading) {
      return false;
    }
    if (this.isError) {
      return this.args.fallbackShowContent;
    }
    return this.isActive;
  }
}, _applyDecoratedDescriptor(_class.prototype, "isActive", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "isActive"), _class.prototype), _class);
export { FeatureActivationGate as default };